import type { UseQueryResult } from "@tanstack/react-query";

import { useUserScopedQuery } from "../../query/scope";
import { fetchMe, type MeResponse } from "./api";

// Хук «текущий user». User-scoped запрос (см. `src/query/scope.ts`) —
// принадлежит пользователю, а не организации, смена активной организации
// его ключ не меняет. Обёртка сама требует identity: `<ProtectedRoute>`
// рендерит детей только при наличии identity-флага, но extra-страховка
// (запрос отключён без identity) защищает от гонок при logout'е: queryFn
// не выстрелит после очистки store до redirect'а. Сам запрос
// аутентифицируется HttpOnly cookie.
export function useMe(): UseQueryResult<MeResponse, Error> {
  return useUserScopedQuery<MeResponse>({
    key: ["me"],
    queryFn: () => fetchMe(),
    retry: false,
  });
}
